import { fetchModalHTML } from "./modals";

const preload = (() => {
   const preloadedImages = {};
   const preloadedModals = {};
   return {
      modal: {
         fetch(id, force = false) {
            if (preloadedModals[id] && !force) {
               return;
            }
				fetchModalHTML(id)
					.then((html) => {
						preloadedModals[id] = html;
					});
         },
         get(id) {
            return preloadedModals[id];
         },
      },
      image: {
         fetch(src, force = false){
            if (preloadedImages[src] && !force) {
               return;
            }
            preloadedImages[src] = new Image();
            preloadedImages[src].src = src;
         },
         getAll() {
            return preloadedImages;
         },
      },
   };
})();

export {
   preload,
};